import api from './abstract';

const historyApi = {
    getVideoLectureList() {
        return api.get('/history/video-lectures/list');
    }
};

export default historyApi;